module.exports = __webpack_public_path__ + "img/ocb2.5663446d.png";